/**
 * IONLOOP — page-level UI utilities (cookie banner,
 * language switching, Bootstrap modal helpers, quick settings).
 *
 * Extracted from the legacy chatbot.js file which mixed chat logic with
 * unrelated page functionality. The chat engine has been removed; this
 * module preserves the non-chat page behavior.
 */

import $ from 'jquery';
import { Modal } from 'bootstrap';

window.$ = window.jQuery = $;

// ── Bootstrap modal helpers ────────────────────────────────────────────────

function ionloopShowModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var inst = Modal.getInstance(el);
    if (!inst) {
        inst = new Modal(el);
    }
    inst.show();
}

function ionloopHideModal(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var inst = Modal.getInstance(el);
    if (inst) inst.hide();
}

function ionloopSetPageDimmer(show) {
    var ld = document.getElementById('loading1');
    if (!ld) return;
    if (show) {
        ld.style.cssText =
            'display: block; filter: blur(1px); background-color: rgba(0,0,0,0.45); width: 100%; height: 100%; top: 0; left: 0; position: fixed; z-index: 1040; pointer-events: auto;';
        ld.setAttribute('aria-hidden', 'false');
    } else {
        ld.style.cssText = 'display: none !important; pointer-events: none;';
        ld.setAttribute('aria-hidden', 'true');
    }
}

// ── IIFE: cookie banner, language switch, quick settings, modals ──
(function () {
    function ionloopApplyStyle(id, cssText) {
        var el = document.getElementById(id);
        if (el) el.style.cssText = cssText;
    }

    function getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/; samesite=strict';
    }

    // Cookie banner buttons.
    $('#sub-1').click(function () {
        setCookie('xmkl_21k1', Date.now() + Math.random(1000), 0.3);
        ionloopApplyStyle('main-elem1', 'display: none');
        ionloopApplyStyle('loading1', 'display: none !important; pointer-events: none;');
    });

    $('#sub-2').click(function () { ionloopShowModal('myModal'); });
    $('#sub-3').click(function () { ionloopHideModal('myModal'); });
    $('#sub-3x').click(function () { ionloopHideModal('myModal'); });

    // Quick settings modal trigger (legacy chat-circle2 replacement).
    $('#chat-circle2').click(function () {
        ionloopShowModal('myModalX-quick');
    });

    // Language toggle.
    var switchCheckbox = document.getElementById('flexSwitchCheckChecked');
    function toggleLanguage() {
        window.location.replace('https://www.ionloop.trade/lv/');
    }
    if (switchCheckbox) {
        switchCheckbox.addEventListener('change', toggleLanguage);
    }

    // ── Window load: cookie banner, language default ──────
    window.addEventListener('load', function () {
        var kmhh = getCookie('language');
        if (kmhh === null || kmhh === undefined) {
            setCookie('language', 'english', 0.3);
        }

        var x = getCookie('xmkl_21k1');
        if (x !== null) {
            ionloopApplyStyle('main-elem1', 'display: none !important');
            ionloopApplyStyle('loading1', 'display: none !important; pointer-events: none;');
        } else {
            if (x === null || x === undefined) {
                ionloopApplyStyle('main-elem1', 'bottom 100ms ease 0s; position: fixed; display: flex; left: 0; height: 80px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
                ionloopApplyStyle('loading1', 'filter: blur(1px); background-color: rgba(0,0,0,0.5); width: 100%; height: 100%; top: 0px; position: fixed; z-index: 1000;');
            }
        }

        // Polling interval: re-check cookie banner visibility.
        setInterval(function () {
            var x = getCookie('xmkl_21k1');
            if (x === null) {
                var width = document.body.offsetWidth;
                if (width <= 997 && width >= 722) {
                    ionloopApplyStyle('main-elem1', 'bottom 100ms ease 0s; position: fixed; display: flex; left: 0; height: 80px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
                    ionloopApplyStyle('loading1', 'filter: blur(1px); background-color: rgba(0,0,0,0.5); width: 100%; height: 100%; top: 0px; position: fixed; z-index: 1000;');
                }
                if (width <= 721 && width >= 472) {
                    ionloopApplyStyle('main-elem1', 'bottom 100ms ease 0s; position: fixed; left: 0; height: 180px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
                    ionloopApplyStyle('loading1', 'filter: blur(1px); background-color: rgba(0,0,0,0.5); width: 100%; height: 100%; top: 0px; position: fixed; z-index: 1000;');
                }
                if (width <= 472) {
                    ionloopApplyStyle('main-elem1', 'bottom 100ms ease 0s; position: fixed; left: 0; height: 180px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
                    ionloopApplyStyle('loading1', 'filter: blur(1px); background-color: rgba(0,0,0,0.5); width: 100%; height: 100%; top: 0px; position: fixed; z-index: 1000;');
                }
                if (width >= 1300) {
                    ionloopApplyStyle('main-elem1', 'bottom 100ms ease 0s; position: fixed; display: flex; left: 0; height: 80px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
                    ionloopApplyStyle('loading1', 'filter: blur(1px); background-color: rgba(0,0,0,0.5); width: 100%; height: 100%; top: 0px; position: fixed; z-index: 1000;');
                }
            }
        }, 2000);

        // Responsive cookie banner styling (initial).
        var width = document.body.offsetWidth;
        if (width <= 1299 && width >= 978) {
            ionloopApplyStyle('main-x1', 'font-size: 13px;width: 604px; margin-left: 2%; line-height: 25px; margin-top: 16px; display: flex;');
            ionloopApplyStyle('main-x2', 'height: 35px; margin-left: 5%; margin-top: 20px;');
            ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; height: 21px;  margin-top: 1px;  scale: 0.88;');
        }
        if (width <= 997 && width >= 722) {
            ionloopApplyStyle('main-x1', 'font-size: 11px;width: 450px; margin-left: 2%; line-height: 16px; margin-top: 16px; display: flex;');
            ionloopApplyStyle('main-x2', 'height: 35px; margin-left: 3%; margin-top: 20px;');
            ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; height: 21px; margin-top: 1px;');
        }
        if (width <= 721 && width >= 472) {
            ionloopApplyStyle('main-x1', 'font-size: 11px;width: 450px; margin-left: 2%; line-height: 16px; margin-top: 16px; display: flex;');
            ionloopApplyStyle('main-x2', 'height: 35px; width: 50%; margin-left: 3%; margin-top: 20px;');
            ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; margin-left: 25px; height: 21px; margin-top: 1px;');
        }
        if (width <= 472) {
            ionloopApplyStyle('main-x1', 'font-size: 11px;width: 95%; margin-left: 2%; line-height: 16px; margin-top: 16px;');
            ionloopApplyStyle('main-x2', 'height: 35px; width: 100%; justify-content: center; display: flex; margin-top: 20px;');
            ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; margin-left: 5px; height: 21px; margin-top: 1px;');
            ionloopApplyStyle('sub-2', 'padding: 0.58rem 1.25rem; font-size: 11px;');
            ionloopApplyStyle('sub-1', 'line-height: 1.5; font-size: 11px; padding: 0.48rem 1.25rem;');
        }
        if (width >= 1300) {
            ionloopApplyStyle('main-x1', 'font-size: 14px;width: 763px; margin-left: 8%; line-height: 25px; margin-top: 16px; display: flex;');
            ionloopApplyStyle('main-x2', 'height: 35px; margin-left: 16%; margin-top: 20px;');
            ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; height: 21px;  margin-top: 1px; scale: 0.88;');
            ionloopApplyStyle('sub-2', 'padding: 0.58rem 1.25rem; font-size: 13px;');
            ionloopApplyStyle('sub-1', 'line-height: 1.5; font-size: 13px; padding: 0.48rem 1.25rem;');
        }
    });

    window.addEventListener('resize', function (event) {
        var width = document.body.offsetWidth;
        var cookieBanner = getCookie('xmkl_21k1');

        if (cookieBanner !== null) {
            ionloopApplyStyle('main-elem1', 'display: none !important');
        } else {
            if (width <= 1299 && width >= 978) {
                ionloopApplyStyle('main-x1', 'font-size: 13px;width: 604px; margin-left: 2%; line-height: 25px; margin-top: 16px; display: flex; scale: 0.88;');
                ionloopApplyStyle('main-x2', 'height: 35px; margin-left: 5%; margin-top: 20px;');
                ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; height: 21px;  margin-top: 1px; scale: 0.88;');
            }
            if (width <= 997 && width >= 722) {
                ionloopApplyStyle('main-x1', 'font-size: 11px;width: 450px; margin-left: 2%; line-height: 16px; margin-top: 16px; display: flex;');
                ionloopApplyStyle('main-x2', 'height: 35px; margin-left: 3%; margin-top: 20px;');
                ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; height: 21px; margin-top: 1px;');
                ionloopApplyStyle('main-elem1', 'position: fixed; display: flex; left: 0; height: 80px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
            }
            if (width <= 721 && width >= 472) {
                ionloopApplyStyle('main-x1', 'font-size: 11px;width: 450px; margin-left: 2%; line-height: 16px; margin-top: 16px; display: flex;');
                ionloopApplyStyle('main-x2', 'height: 35px; width: 50%; margin-left: 3%; margin-top: 20px;');
                ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; margin-left: 25px; height: 21px; margin-top: 1px;');
                ionloopApplyStyle('main-elem1', 'position: fixed; left: 0; height: 180px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
            }
            if (width <= 472) {
                ionloopApplyStyle('main-x1', 'font-size: 11px;width: 95%; margin-left: 2%; line-height: 16px; margin-top: 16px;');
                ionloopApplyStyle('main-x2', 'height: 35px; width: 100%; justify-content: center; display: flex; margin-top: 20px;');
                ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; margin-left: 5px; height: 21px; margin-top: 1px;');
                ionloopApplyStyle('main-elem1', 'position: fixed; left: 0; height: 180px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
                ionloopApplyStyle('sub-2', 'padding: 0.58rem 1.25rem; font-size: 11px;');
                ionloopApplyStyle('sub-1', 'line-height: 1.5; font-size: 11px; padding: 0.48rem 1.25rem;');
            }
            if (width >= 1300) {
                ionloopApplyStyle('main-x1', 'font-size: 14px;width: 763px; margin-left: 8%; line-height: 25px; margin-top: 16px; display: flex; scale: 0.88;');
                ionloopApplyStyle('main-x2', 'height: 35px; margin-left: 16%; margin-top: 20px;');
                ionloopApplyStyle('main-c2', 'color: rgb(112, 133, 153); width: 153px; height: 21px;  margin-top: 1px; scale: 0.88;');
                ionloopApplyStyle('main-elem1', 'position: fixed; display: flex; left: 0; height: 80px; bottom: 0; width: 100%; z-index: 1007; background-color: rgb(250, 251, 252); color: white; text-align: center;');
                ionloopApplyStyle('sub-2', 'padding: 0.58rem 1.25rem; font-size: 13px;');
                ionloopApplyStyle('sub-1', 'line-height: 1.5; font-size: 13px; padding: 0.48rem 1.25rem;');
            }
        }
    }, true);

    ['myModalX-quick', 'myModal'].forEach(function (modalId) {
        var el = document.getElementById(modalId);
        if (el) {
            el.addEventListener('hidden.bs.modal', function () {
                ionloopSetPageDimmer(false);
            });
        }
    });
})();